import { Component, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MetricSelectorComponent } from 'src/app/reusables/metric-selector/metric-selector.component';
import { MetricSelectorService } from 'src/app/reusables/metric-selector/metric-selector.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleSettingsView } from 'src/shared/models/module-manager/module-manager-settings.models';

@Component({
    selector: 'cv-calculated-metric-breakdown-settings',
    templateUrl: './calculated-metric-breakdown-settings.component.html',
    styleUrls: ['./calculated-metric-breakdown-settings.component.scss']
})
export class CalculatedMetricBreakdownSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    settings = {
        all: [], // all states, persisted by moduleManager.addSetting
        selectedMetrics: [], // linked to metric selector
        metricFilter: 10, // value to pull calculated metrics
        selectedMetricsText: '',
    };
    @Output() metricFilter: number = this.settings.metricFilter;

    slideout = ModuleSettingsView.Slideout;
    modal = ModuleSettingsView.Modal;

    constructor(
        private metricSelectorService: MetricSelectorService,
    ) { }


    get stateKey() {
        const stateKey = this.moduleManager?.getModuleKey();
        if (stateKey == null)
            throw Error("stateKey could not be determined. Neither moduleManager is set.");
        return stateKey;
    }

    ngOnInit(): void {
        this.moduleManager.addSetting({
            name: "SelectedMetrics", // linked to metric selector
            getValue: () => this.settings.selectedMetrics,
            onSettingLoaded: (value) => {
                this.settings.selectedMetrics = value;
            },
            defaultValue: this.settings.selectedMetrics,
        });

        this.moduleManager.addSetting({
            name: "SelectedMetricsText", // show selected metric text
            getValue: () => this.settings.selectedMetricsText,
            onSettingLoaded: (value) => {
                this.settings.selectedMetricsText = value;
            },
            defaultValue: this.settings.selectedMetricsText,
        });

        this.moduleManager.customSettingsAdded = true;
    }

    openMetricSelector() {
        const currentSelectedMetrics = this.moduleManager.customSettings.SelectedMetrics.getValue();
        this.metricSelectorService.filterParams = {metricType: '10'};
        const metricSelector = this.metricSelectorService.openModal(MetricSelectorComponent, this.moduleManager, currentSelectedMetrics, true);
        const newSelectedMetrics = [];
        let newSelectedMetricsText = '';
        metricSelector.result.then((metricSelectorResult) => {
            if (metricSelectorResult) {
                metricSelectorResult?.forEach(m => {
                    newSelectedMetrics.push({
                        Id: m.MetricID,
                        Abbreviation: m.Abbreviation,
                        Name: m.MetricName,
                        ConversionType: m.ConversionType,
                        CustomName: m.MetricCustomName
                    });
                });
                this.settings.selectedMetrics = newSelectedMetrics;
                this.settings.selectedMetricsText = this.getMetricDisplayName(newSelectedMetrics[0]); //we can grab just the first name since this widget only supports one metric
            }
        });
    }

    async removeMetric(metricId: number): Promise<void> {
        const index = this.settings.selectedMetrics.findIndex(m => m.Id === metricId);
        if (index > -1) {
            const updatedMetrics = this.settings.selectedMetrics.filter(m => m.Id !== metricId);
            this.settings.selectedMetrics = updatedMetrics;
            this.settings.selectedMetricsText = '';
            await this.metricSelectorService.updateSelectedMetrics(updatedMetrics);
        }
    }

    async removeAllMetrics(): Promise<void> {
        this.settings.selectedMetrics = [];
        this.settings.selectedMetricsText = '';
        await this.metricSelectorService.updateSelectedMetrics(this.settings.selectedMetrics);
    }

    public getMetricDisplayName(metric) {
        if (metric.CustomName && metric.CustomName != "")
            return metric.CustomName + "*";

        return metric.Abbreviation;
    }
}
